import { render, staticRenderFns } from "./FilingDataComponent.vue?vue&type=template&id=c9a13324&"
import script from "./FilingDataComponent.vue?vue&type=script&lang=js&"
export * from "./FilingDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports